import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { UseFormReset } from 'react-hook-form';

import { getCompanyProfile } from '../api';
import { CompanyProfile } from '../types';

import { CompanyProfileForm } from './use-company-profile.form';

type useGetCompanyProfile = {
  reset?: UseFormReset<CompanyProfileForm>;
  enabled?: boolean;
};

export const useGetCompanyProfile = ({ reset }: useGetCompanyProfile) => {
  const companyProfileQuery = useQuery<CompanyProfile>({
    queryKey: ['companyProfile'],
    queryFn: getCompanyProfile,
    staleTime: Infinity,
    enabled: true,
  });

  useEffect(() => {
    if (
      companyProfileQuery.isError ||
      companyProfileQuery.isFetched === false ||
      companyProfileQuery.data === undefined
    )
      return;
    reset?.(companyProfileQuery.data);
  }, [
    companyProfileQuery.isError,
    companyProfileQuery.isFetched,
    companyProfileQuery.data,
    reset,
  ]);

  return companyProfileQuery;
};
